import * as AIAHD201611 from "./Aia/AIAHD201611";
import * as AIAHD201706 from "./Aia/AIAHD201706";
import * as GEHD201412 from "./Ge/GEHD201412";
import * as GEHD201708 from "./Ge/GEHD201708";
import AVIVAHD201407 from "./Aviva/AVIVAHD201407";
import AVIVAHD201910 from "./Aviva/AVIVAHD201910";
import SINGLIFEHD202202 from "./Aviva/SINGLIFEHD202202";
import SINGLIFEHD202308 from "./Aviva/SINGLIFEHD202308";
import AXAHD202404 from "./Axa/AXAHD202404";

// Aia
export const AIA_HDF_IDS = ["AIAHD201706", "AIAHD201611"];
export const AIA_FORMS = { AIAHD201611, AIAHD201706 };

// Aviva
export const AVIVA_HDF_IDS = ["AVIVAHD201407", "AVIVAHD201910", "SINGLIFEHD202202", "SINGLIFEHD202308"];
export const AVIVA_FORMS = { AVIVAHD201407, AVIVAHD201910, SINGLIFEHD202202, SINGLIFEHD202308 };

// Ge
export const GE_HDF_IDS = ["GEHD201412", "GEHD201708"];
export const GE_FORMS = { GEHD201412, GEHD201708 };

// Prudential
export const PRUDENTIAL_HDF_ID = "PRUHD201611";
export const PRUDENTIAL_HDF_202101_ID = "PRUHD202101";
export const PRUDENTIAL_HDF_IDS = [PRUDENTIAL_HDF_ID, PRUDENTIAL_HDF_202101_ID];

// Tokiomarine
export const TOKIOMARINE_HDF_ID = "TMLHD201702";

// AXA
export const AXA_HDF_IDS = ["AXAHD202404"];
export const AXA_FORMS = { AXAHD202404 };
/**
 * Common close message
 * @type {string}
 */
export const CLOSE_MESSAGE = [
  "You are about to close the Health Declaration Form.\n",
  "Any changes that is not saved will be lost.\n",
  "Proceed?",
].join("");

/**
 * Common smbmit failure message
 * @type {string}
 */
export const SUBMIT_FAILURE_MESSAGE = [
  "The form failed to submit. ",
  "Please ensure you have completed all required fields as marked.",
].join("");



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/constants.js